import { render } from "./TakersPage.vue?vue&type=template&id=527ca3af&ts=true"
import script from "./TakersPage.ts?vue&type=script&lang=ts"
export * from "./TakersPage.ts?vue&type=script&lang=ts"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__